export class CancellableOperation<T> {
  private abortController: AbortController;

  constructor(
    private operation: (signal: AbortSignal) => Promise<T>,
    private apply: (value: T) => void,
  ) {
    this.abortController = new AbortController();
  }

  get signal() {
    return this.abortController.signal;
  }

  cancel() {
    this.abortController.abort();
  }

  async execute() {
    try {
      const result = await this.operation(this.abortController.signal);

      if (!this.signal.aborted) {
        this.apply(result);
      }
    } finally {
      this.cancel();
    }
  }
}
